import { Box, Typography, Button, Container } from '@mui/material';
import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";


const About = () => {
  return (
    <Container
      maxWidth={false}
      sx={{
        maxWidth: '1400px',
        mx: 'auto',
        px: { xs: 2, md: 4 },
        py:15
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          mt: 10,
          overflow: 'hidden',
          alignItems: 'center',
        }}
      >
        {/* Left Section - Text & Content */}
        <Box
          sx={{
            flex: 1,
            background: 'linear-gradient(90deg, #111 70%, transparent)',
            color: '#fff',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            px: { xs: 1, md: 6 },
            py: { xs: 6, md: 0 },
          }}
        >
          <Typography
            variant="overline"
            sx={{ color: '#C29D59', fontWeight: 600, letterSpacing: 1 }}
          >
            Started in 1991
          </Typography>

          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              mb: 2,
              mt: 1,
              lineHeight: 1.2,
              fontSize:{sm:"45px",xs:"32px"}
            }}
          >
            Crafting Spaces{' '}
            <Box component="span" sx={{ color: '#C29D59' }}>
              That <br /> Reflect
            </Box>{' '}
            Your Style
          </Typography>

          {/* Features Section */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
              rowGap: 2,
              columnGap: 4,
              my: 3,
            }}
          >
            {[
              'Latest Technologies',
              'High-Quality Designs',
              '5 Years Warranty',
              'Residential Design',
            ].map((text, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                }}
              >
                <CheckCircleIcon sx={{ color: '#C29D59', fontSize: 22 }} />
                <Typography sx={{ fontSize: '1rem', color: '#fff' }}>
                  {text}
                </Typography>
              </Box>
            ))}
          </Box>

          <Typography sx={{ maxWidth: 500, mb: 4, color: '#ccc' }}>
            At InteriorVista, we believe that every space should tell a story.
            Our team of creative designers brings luxury, comfort, and
            innovation to your home or office.
          </Typography>

    
          <Button
                    variant="outlined"
                    endIcon={<ArrowOutwardIcon />}
                    sx={{
                      alignSelf: "flex-start",
                      mt: 1,
                      borderColor: "#d2ad6d",
                      borderRadius: "30px",
                      color: "white",
                      
                      px: 3,
                      py: 1.2,
                      textTransform: "none",
                      fontWeight: "bold",
                      "&:hover": {
                        backgroundColor: "#d2ad6d",
                        color: "#000",
                      },
                    }}
                  >
                    More About Us
                  </Button>
        </Box>

        {/* Right Section - Image */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            py: { xs: 4, md: 0 },
          }}
        >
          <motion.img
            src="/images/about-b.jpg"
            alt="Interior Design"
            style={{
              width: '100%',
              height: '60%',
              objectFit: 'cover',
              borderRadius: "20px",
            }}
            initial={{ opacity: 0, scale: 1.05 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default About;
